/** Returns an in-app path from login/signup location state, else fallback. */
export function resolveAuthRedirect(
  state: unknown,
  fallback = '/',
): string {
  if (!state || typeof state !== 'object') return fallback
  const from = (state as { from?: unknown }).from
  if (typeof from !== 'string') return fallback
  if (!from.startsWith('/') || from.startsWith('//')) return fallback
  return from
}
